import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import BaseChart from '@/base-ui/chart'
import { IDataType } from '../types/type'


export default _defineComponent({
  props: {
    roseData: { type: null, required: true }
  } as unknown as undefined,
  setup(__props: {
  roseData: IDataType
}) {

const props = __props


const options = computed(() => {
  return {
    // legend: {
    //   top: 'bottom'
    // },
    // 顯示工具列
    toolbox: {
      show: true,
      feature: {
        dataView: {
          show: true,
          readOnly: false,
          title: 'data view',
          lang: ['data view', 'close', 'reset']
        },
        restore: { show: true, title: 'reset' },
        saveAsImage: { show: true, title: 'save' }
      }
    },
    // 顯示提示框
    tooltip: {
      trigger: 'item'
    },
    legend: {
      left: 'center',
      top: 'bottom',
      data: []
    },
    series: [
      {
        name: '商品數量',
        type: 'pie',
        radius: [5, 90],
        center: ['50%', '50%'],
        roseType: 'area',
        itemStyle: {
          borderRadius: 8
        },
        data: props.roseData
      }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BaseChart), { options: _unref(options) }, null, 8, ["options"])
  ]))
}
}

})